export const FOCUS_VISIBLE_CLASS = 'fr-ec-show-focus-border'

export const initFocusVisible = () => {
  document.addEventListener('keydown', e => {
    if (e.key === 'Tab') {
      document.documentElement.classList.add(FOCUS_VISIBLE_CLASS)
    }
  })
  document.addEventListener('click', () => {
    document.documentElement.classList.remove(FOCUS_VISIBLE_CLASS)
  })
}
